<template>
  <el-popover
    placement="bottom-start"
    width="206"
    v-model:visible="visible"
    @show="show"
  >
    <div class="user-info" v-loading="isShowLoading">
      <el-carousel 
        :indicator-position="userInfo.facephotos.length > 1 ? '' : 'none'" 
        :arrow="userInfo.facephotos.length > 1 ? '' : 'never'" 
        height="210px" 
        v-if="userInfo.facephotos && userInfo.facephotos.length > 0">
        <el-carousel-item v-for="item in userInfo.facephotos" :key="item.faceId">
          <img :src="item.faceUrl" style="width: 206px; height: 210px" alt="">
        </el-carousel-item>
      </el-carousel>
      <el-image
        v-if="userInfo.avatar"
        style="width: 206px; height: 210px"
        :src="$url + userInfo.avatar"
        fit="cover">
      </el-image>
      <el-image
        v-if="userInfo['电子签名']"
        style="width: 206px"
        :src="$url + userInfo['电子签名'].replace('userfiles', 'confiles')"
        fit="cover">
      </el-image>
      <p class="title real-name">
        {{ userInfo.realname }}
        <span 
          class="lable" 
          v-if="userInfo.type !== undefined && userLabel[userInfo.type]" 
          :style="{ 
            background:userLabel[userInfo.type].background, 
            color:userLabel[userInfo.type].color 
          }">
          {{ userLabel[userInfo.type].label || userLabel[userInfo.type].name }}
        </span>
      </p>
      <div class="user-detaile">
        <p class="list" v-for="item in showInfo" :key="item.label">
          <span class="title">{{ item.label }}</span>
          <span class="content">
            <template v-if="item.label === '联系号码'">
              <userPhone :user="info" />
            </template>
            <template v-else>
              {{ item.value }}
            </template>
          </span>
        </p>
      </div>
    </div>
    <template #reference>
      <p @mouseenter="visible = true" @mouseleave="visible = false">
        <i class="iconfont icon-gerenxinxi" :style="{color: iconColor, position: 'relative', top: '2px', marginRight: '2px'}" />
        {{ userInfo.realname }}
        <template v-if="checkedInfo && checkedInfo.length > 0 && getCheckedFieldsText">
          <span>({{ getCheckedFieldsText }})</span>
        </template>
      </p>
    </template>
  </el-popover>
</template>

<script>
import typeObj from "@/components/common/multipleChoice/color";
import { getnewuserbindmsg  } from '@/port/clientSide/multipleChoice.js'
import { getusertiplist } from '@/port/admins/organizationUser'
import { getOrgShowName } from "@/api/global.js";
import { defineAsyncComponent } from "vue";
import { cloneDeep } from "lodash";
export default {
  name: 'relationUserInfo',
  data () {
    return {
      moreInfoArrOption: {
        username: '登录名',
        sex: '性别',
        birthday: '出生年月',
        phone: '联系号码'
      },
      isShowLoading: true,
      userInfo: {},
      userLabel: {},
      visible: false
    }
  },
  props: {
    info: {
      type: Object,
      default: () => { return {} }
    },
    iconColor: {
      type: String,
      default: ''
    },
    isNewInfo: {
      type: Boolean,
      default: true
    },
    moreInfo: {
      type: Array,
      default: () => { return [] }
    },
    checkedInfo: {
      type: Array,
      default: () => { return [] }
    },
  },
  components: {
    userPhone: defineAsyncComponent(() => import('@/components/clientSide/formFillinPageChild/widget/cpns/userPhone.vue')),
  },
  computed: {
    showInfo () {
      let arr = []
      const filterKeys = ['userId', 'realphone', 'realname', 'orgname', 'userTip', 'type', 'avatar', '电子签名', 'facephotos']
      if (JSON.stringify(this.userInfo) !== '{}') {
        for (const key of this.moreInfo) {
          let value = this.userInfo[key]
          if (key === 'sex') {
            value = value == 0 ? '男' : '女'
          }
          if (!filterKeys.includes(key) && value) {
            const obj = {
              label: (this.moreInfoArrOption[key] || key).replace('部门：', ''),
              value
            }
            arr.push(obj)
          }
        }
      }
      return arr
    },
    getCheckedFieldsText() {
      if (!this.checkedInfo || !this.checkedInfo.length) return '';

      const excludedFields = ['电子签名', 'facephotos', 'avatar'];
      console.log("this.userInfo==", this.userInfo);

      const filteredFields = this.checkedInfo.filter(field => !excludedFields.includes(field));
      console.log("filteredFields==", filteredFields);
      const values = filteredFields.map(field => {
          let val = this.userInfo[field];
          if (field === 'sex') {
            val = val == 0 ? '男' : '女'
          }
          if (field === '角色') {
            val = this.userInfo['角色'] ? this.userInfo['角色'] : this.userInfo['rolename'] ? this.userInfo['rolename'] : ''
          }
          if (field === '部门') {
            val = this.userInfo['部门'] ? this.userInfo['部门'] : this.userInfo['orgname'] ? this.userInfo['orgname'] : ''
          }
          if (field === 'type') {
            val = this.userLabel[val] && this.userLabel[val].label ? this.userLabel[val].label : ''
          }
          return val;
      }).filter(val => val); // 过滤掉 undefined 或 null 的值
      return values.join(',');
    }
  },
  watch: {
    isNewInfo: {
      handler (val) {
        if (!val) {
          this.isShowLoading = false
        }
      },
      immediate: true
    },
    info: {
      handler (val) {
        if (val) {
          if (JSON.stringify(this.userInfo) === '{}') {
            this.userInfo = cloneDeep(val)
          }
          if (val.type !== undefined) {
            this.userLabel[val.type] = val.userTip
          }
        }
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    async show () {
      if (this.isNewInfo && this.isShowLoading) {
        this.getUserType()
        const { code, data } = await getnewuserbindmsg({ userId: this.userInfo.userId })
        if (code == 0) {
          const info = {
            realname: data.realname
          }
          for (const key of this.moreInfo) {
            info[key] = data[key] !== undefined ? data[key] : info[key]
            if (info[key]) {
              if (key === 'facephotos') { 
                info[key].forEach(item => {
                  let str = item.faceUrl
                  let userInfo = JSON.parse(localStorage.getItem('user'));
                  str = str.replace('userfiles', 'confiles')
                  item.faceUrl = this.$url + str + '?accesstoken=' + userInfo.accesstoken
                })
              } else if (key.search('部门') !== -1 && Array.isArray(info[key])) {
                info[key] = info[key].map(item => {
                  return getOrgShowName(item)
                }).join()
              }
            }
          }
          this.userInfo = info
        }
        this.isShowLoading = false
      } 
    },
    // 获取用户标签
		async getUserType () {
      const res = await getusertiplist({
        curpage: 1,
        pagesize: 99999
      })
      if (res.code === 0) {
        const obj = {}
        for (const i of res.data) {
          obj[i.keytype] = {
            label: i.name,
            color: typeObj[i.colours].color,
            background: typeObj[i.colours].background
          }
        }
        this.userLabel = obj
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .user-info {
    .el-image {
      margin-top: 4px;
    }
    .title {
      color: #333333;
      font-size: 14px;
      font-weight: bold;
    }
    .real-name {
      padding: 8px 0 14px 0;
      border-bottom: 1px solid #DFE1E8;
      font-size: 18px;
    }
    .lable {
      font-size: 12px;
      font-weight: normal;
      padding: 2px 3px;
    }
    .user-detaile {
      max-height: 200px;
      overflow-y: auto;
    }
    .list {
      padding-top: 12px;
      display: flex;
      justify-content: space-between;
    }
    .content {
      color: #333333;
      display: inline-block;
      text-align: left;
      width: 110px;
    }
  }
</style>